module.exports = __webpack_public_path__ + "static/media/ipsum_brand_old.0ed7ccda.png";